import type { DirectionalIndicatorEdge, DropParentDirection } from './core';

export const DND_INDICATOR_SURFACE_CLASS =
  'pointer-events-none absolute rounded-sm border border-editor-primary/45 bg-editor-primary/20 shadow-[0_8px_20px_hsl(var(--editor-primary)/0.24)]';

export const DND_ROOT_INDICATOR_SURFACE_CLASS =
  'pointer-events-none absolute rounded-md border border-editor-primary/55 bg-editor-primary/20 shadow-[0_10px_24px_hsl(var(--editor-primary)/0.28)]';

export const DND_ACTIVE_SCOPE_CLASS = 'rounded-md ring-2 ring-editor-primary/55';

const DRAG_THUMBNAIL_BASE_CLASS =
  'group-data-[dnd-dragging=true]:!max-w-[320px] group-data-[dnd-dragging=true]:!max-h-[240px] group-data-[dnd-dragging=true]:mx-auto group-data-[dnd-dragging=true]:opacity-75 group-data-[dnd-dragging=true]:shadow-2xl';

export const getPlacementIndicatorClassName = (edge: DirectionalIndicatorEdge): string =>
  edge === 'top' || edge === 'bottom'
    ? `${DND_INDICATOR_SURFACE_CLASS} left-0 right-0 h-8 ${edge === 'top' ? '-top-9' : '-bottom-9'}`
    : `${DND_INDICATOR_SURFACE_CLASS} bottom-0 top-0 w-8 ${edge === 'left' ? '-left-9' : '-right-9'}`;

const PREVIEW_GAP_CLASS_BY_EDGE: Record<DirectionalIndicatorEdge, string> = {
  top: 'mt-4',
  bottom: 'mb-4',
  left: 'ml-4',
  right: 'mr-4',
};

export const getPreviewGapClassName = (edge: DirectionalIndicatorEdge): string =>
  PREVIEW_GAP_CLASS_BY_EDGE[edge];

export const getRootDropIndicatorClassName = (direction: DropParentDirection): string =>
  direction === 'horizontal'
    ? `${DND_ROOT_INDICATOR_SURFACE_CLASS} bottom-0 top-0 w-8 -right-9`
    : `${DND_ROOT_INDICATOR_SURFACE_CLASS} left-0 right-0 h-8 -bottom-9`;

export const getParentDropSurfaceIndicatorClassName = (direction: DropParentDirection): string =>
  direction === 'horizontal'
    ? `${DND_INDICATOR_SURFACE_CLASS} bottom-0 top-0 w-8 -right-9`
    : `${DND_INDICATOR_SURFACE_CLASS} left-0 right-0 h-8 -bottom-9`;

export function getDragThumbnailClassName({
  isPageEditor,
}: {
  isPageEditor: boolean;
}): string | undefined {
  if (!isPageEditor) {
    return undefined;
  }

  return DRAG_THUMBNAIL_BASE_CLASS;
}
